import React, { useState } from 'react';
import { Checkbox, Col, Input, Row } from 'antd';
import { Form } from 'react-bootstrap';
import './ipsscheduling.css';

import dayjs from 'dayjs';
import DatePicker from 'components/DatePicker';

const { TextArea } = Input;

function IPSProjectScheduling(props) {
  const { project, handleProjectDetailUpdate,isReadOnly ,expediteReasons,p6Sources, phaseDetails,phaseId} = props;
  
  // const { ipsProjectDetails } = project || {};

  const [statusNote, setStatusNote] = useState(
    phaseDetails ? phaseDetails.shcdStatusNote : ''
  );

  
  const dateFormat = 'MMMM DD, YYYY';

  const handleStatusNoteChange = (e) => {
    setStatusNote(e.target.value);
  };

  return (
    <div className='border-container'>
      <section className='padding-container'>
        <Row gutter={16}>
          <Col xs={24} md={12} xl={8}>
            <div className='section-container'>
              <div className='date-section-container'>
                <strong>Checklist Release Date : </strong>
              </div>
              <span>{project.tclReleaseDate}</span>
            </div>
          </Col>
          <Col xs={24} md={12} xl={4}>
            <div className='section-container' style={{ textAlign: 'center' }}>
              <Checkbox
                id='expedite'
                checked={
                  phaseDetails && phaseDetails.expediteFlag === 'Y'
                }
                onChange={(e) => {
                  let value = e.target.checked ? 'Y' : 'N';

                  handleProjectDetailUpdate(value, 'EXPEDITE_FLAG', 'string',phaseId);
                }}
                name='selected'
                style={{
                  display: 'flex',
                  border: 'none',
                  padding: 0,
                  margin: 0,
                }}
                disabled={isReadOnly}
              />
              <strong
                style={{
                  border: 'none',
                  padding: 0,
                  margin: '0px 0px 0px 5px',
                }}
              >
                <label style={{ border: 'none', margin: 0 }}>Expedite</label>
              </strong>
            </div>
          </Col>
          <Col xs={24} md={12} xl={8}>
            <div className='section-container'>
              <div className='date-section-container'>
                <b>Expedite Reason :</b>
              </div>
              <Form.Control
                as='select'
                id='user-myprojects-selector'
                value={
                  phaseDetails ? phaseDetails.expediteReason : ''
                }
                onChange={(e) => {
                  handleProjectDetailUpdate(
                    e.target.value,
                    'EXPEDITE_REASON',
                    'string',
                    phaseId
                  );
                }}
                disabled={
                  !(
                    phaseDetails && phaseDetails.expediteFlag === 'Y'
                  ) || isReadOnly
                }
              >
                <option value=''>Select</option>
                {expediteReasons?.map((eReason) => (
                  <option value={eReason} key={eReason}>
                    {eReason}
                  </option>
                ))}
              </Form.Control>
            </div>
          </Col>
          <Col xs={24} md={12} xl={4}>
            <Row>
              <strong> EPC Project :</strong>
              {project.epcFlag === 'Y'? 'Yes' : 'No'}
            </Row>
            <Row>
              <strong> IPP Project :</strong>
              {project.ippFlag === 'Y' ? 'Yes' : 'No'}
            </Row>
            <Row>
              <strong> CIP Project :</strong>
              {project.nercCipFlag &&
                `${project.nercCipFlag === 'Y' ? 'Yes' : 'No'}`}
            </Row>
          </Col>

          <br />
          <Col xs={24} md={24} lg={24} style={{ alignItems: 'center' }}>
            <Row style={{ alignItems: 'center' }} className='datenotes'>
              <Col xs={2}>
                <b>Status Note:</b>
              </Col>
              <Col xs={22}>
                <TextArea
                  style={{ height: 100 }}
                  onChange={handleStatusNoteChange}
                  onBlur={() => {
                    handleProjectDetailUpdate(
                      statusNote,
                      'SHCD_STATUS_NOTE',
                      'string',
                      phaseId
                    );
                  }}
                  value={statusNote}
                  minLength={0}
                  maxLength={500}
                  disabled={isReadOnly}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={12} lg={8} style={{ alignItems: 'center' }}>
            <Row style={{ textAlign: 'center' }} className='datenotes'>
              <h6>P6 Finish: P-OneLine</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='POnlineFinish'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6OnlineDate &&
                  dayjs(phaseDetails.p6OnlineDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_ONLINE_DATE',
                    'date',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
            <Row style={{ textAlign: 'center' }} className='datenotes'>
              <h6>P6 Finish: AG IFC</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='AGFinish'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6AgifcDate &&
                  dayjs(phaseDetails.p6AgifcDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_AGIFC_DATE',
                    'date',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
            <Row className='datenotes'>
              <h6>P6 Finish: Front Views</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='FrontviewFinish'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6FviewDate &&
                  dayjs(phaseDetails.p6FviewDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_FVIEW_DATE',
                    'date',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
          </Col>
          <Col xs={24} md={12} lg={8} style={{ textAlign: 'center' }}>
            <Row style={{ textAlign: 'center' }} className='datenotes'>
              <h6>P-OneLine Released</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='POneLineReleased'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6OnlineReleaseDate &&
                  dayjs(phaseDetails.p6OnlineReleaseDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_ONLINE_RELEASE_DATE',
                    'date',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
            <Row className='datenotes'>
              <h6>AG IFC Package Released</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='AGPackageReleased'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6AgifcReleaseDate &&
                  dayjs(phaseDetails.p6AgifcReleaseDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_AGIFC_RELEASE_DATE',
                    'date',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
            <Row className='datenotes'>
              <h6>Front Views Released</h6>
              <DatePicker
                autoComplete='off'
                format={dateFormat}
                id='FrontViewsReleased'
                allowClear={false}
                value={
                  phaseDetails &&
                  phaseDetails.p6FviewReleaseDate &&
                  dayjs(phaseDetails.p6FviewReleaseDate)
                }
                onChange={(date, dateString) => {
                  handleProjectDetailUpdate(
                    dateString,
                    'P6_FVIEW_RELEASE_DATE',
                    'date',
                  phaseId
                  );
                }}
                disabled={isReadOnly}
              />
            </Row>
          </Col>
          <Col xs={24} md={12} lg={8} style={{ textAlign: 'center' }}>
            <Row className='datenotes'>
              <h6>Notification Source</h6>
              <Form.Control
                as='select'
                value={
                  phaseDetails && phaseDetails.p6OnlineSource
                    ? phaseDetails.p6OnlineSource
                    : ''
                }
                onChange={(e) => {
                  handleProjectDetailUpdate(
                    e.target.value,
                    'P6_ONLINE_SOURCE',
                    'string',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              >
                <option value=''>Select</option>
                {p6Sources?.map((notification, index) => (
                  <option value={notification} key={index}>
                    {notification}
                  </option>
                ))}
              </Form.Control>
            </Row>
            <Row className='datenotes'>
              <h6>Notification Source</h6>
              <Form.Control
                as='select'
                value={
                  phaseDetails && phaseDetails
                    ? phaseDetails.p6AgifcSource
                    : ''
                }
                onChange={(e) => {
                  handleProjectDetailUpdate(
                    e.target.value,
                    'P6_AGIFC_SOURCE',
                    'string',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              >
                <option value=''>Select</option>
                {p6Sources?.map((notification, index) => (
                  <option value={notification} key={index}>
                    {notification}
                  </option>
                ))}
              </Form.Control>
            </Row>
            <Row className='datenotes'>
              <h6>Notification Source</h6>
              <Form.Control
                as='select'
                value={
                  phaseDetails && phaseDetails.p6FviewSource
                    ? phaseDetails.p6FviewSource
                    : ''
                }
                onChange={(e) => {
                  handleProjectDetailUpdate(
                    e.target.value,
                    'P6_FVIEW_SOURCE',
                    'string',
                    phaseId
                  );
                }}
                disabled={isReadOnly}
              >
                <option value=''>Select</option>
                {p6Sources?.map((notification, index) => (
                  <option value={notification} key={index}>
                    {notification}
                  </option>
                ))}
              </Form.Control>
            </Row>
          </Col>
        </Row>
      </section>
    </div>
  );
}

export default IPSProjectScheduling;
